<a [routerLink]="[item.link]" routerLinkActive="is-active" class="example-item">
  <span class="titleMediumNeutral60 menu-label">{{ item.label }}</span>
  <span class="active-line"></span>
</a>
